import React from "react";
import styled from "styled-components";
import Skeleton from "react-loading-skeleton";

const Item = styled.div`
    display: flex;
    flex-direction: column;
    width: 50%;
    margin: 0;
    padding: 15px 7.5px 25px 7.5px;

    @media (min-width: 540px) {
        width: 33.33%;

        &:not(:nth-child(1)):not(:nth-child(2)):not(:nth-child(3)) {
            display: none;
        }
    }

    @media (min-width: 1280px) {
        width: 25%;

        &:not(:nth-child(1)):not(:nth-child(2)):not(:nth-child(3)) {
            display: block;
        }
    }
`;

const ImageWrap = styled.div`
    display: flex;
    justify-content: center;

    span span {
        display: block;
        width: 140px;
        height: 140px;
        border-radius: 50%;
        margin-bottom: 10px;

        @media (min-width: 768px) {
            width: 200px;
            height: 200px;
        }
    }
`;

const IconsWrap = styled.div`
    display: flex;
    justify-content: center;
`;

function MenuPageSkeletonItem() {
    return (
        <Item>
            <ImageWrap>
                <Skeleton circle={true} />
            </ImageWrap>

            <Skeleton
                style={{
                    display: "block",
                    fontSize: 16,
                    lineHeight: 2,
                    width: "100%",
                }}
            />
            <IconsWrap
                style={{
                    margin: "8px 0 32px 0",
                }}
            >
                <Skeleton
                    circle={true}
                    height={20}
                    width={20}
                    style={{
                        margin: "0 4px",
                    }}
                />
                <Skeleton
                    circle={true}
                    height={20}
                    width={20}
                    style={{
                        margin: "0 4px",
                    }}
                />
            </IconsWrap>
        </Item>
    );
}

export default MenuPageSkeletonItem;
